export const NAV_LIST = {
    countryProfile: { name: "countryProfile" },
    businessEnvironment: { name: "businessEnvironment" },
    bilateralRelations: { name: "bilateralRelations" },
    investmentTradeOpportunities: { name: "investmentTradeOpportunities" },
    tourismPotential: { name: "tourismPotential" },
};
